import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../../components/ButtonComponent";
import Toast from "../../../helpers/Toast";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceListDTO } from "../../../models/Assistance/AssistanceListDTO";
import { GetAssistanceDTO } from "../../../models/Assistance/GetAssistanceDTO";
import { Parameter } from "../../../models/Parameter";
import { AssistanceService } from "../../../services/AssistanceService";
import { CircularProgress } from "@mui/material";
import { useAuth } from "../../../context/AuthContext";
import { BigButton } from "../../../pages/workshop/BigButton";
import { useIntl } from "react-intl";

export default function AssistanceWorkshopListB() {
    //Pagina
    const navigate = useNavigate();
    const { technicianCode } = useAuth();
    const [isLoadingResults, setIsLoadingResults] = useState<boolean>(false);
    const assistanceService = new AssistanceService();
    //Resultados
    const [assistancesData, setAssistancesData] = useState<AssistanceListDTO[]>([]);
    const [page] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState<number>();
    const pageSize = 6;
    const [ShowAll, setShowAll] = useState<boolean>(Utilities.LoadParameterFromURLQuery("showAll", "string", false));

    useEffect(() => {
        fetchData(page ?? 1);
    }, [ShowAll]);

    useEffect(() => {
        const searchUrl: string = Utilities.CreateSearchURL([
            `page=${currentPage ?? 1}`,
            Utilities.AddParamToQueryIfValue("showAll", "string", ShowAll),
            Utilities.AddParamToQueryIfValue("technician", "string", technicianCode)
        ]);

    }, [ShowAll, technicianCode, currentPage]);

    const fetchData = async (page: number) => {
        setIsLoadingResults(true);

        var searchUrl: string = Utilities.CreateSearchURL([
            `page=${page}`,
            Utilities.AddParamToQueryIfValue("showAll", "string", ShowAll),
            Utilities.AddParamToQueryIfValue("technician", "string", technicianCode)
        ]);

        navigate(`/workshop/assistances${searchUrl}`, { replace: true });

        var response = await assistanceService.GetAll(mountSearchParameters(), Utilities.MountSortParameters([]), page, pageSize);

        if (response.success !== true) {
            setAssistancesData([]);
            setPageCount(0);
            setIsLoadingResults(false);
            Toast.Show("error", response.message);
            return;
        }

        setAssistancesData(response.items);
        setPageCount(response.totalPages);
        setIsLoadingResults(false);
        setCurrentPage(page);
    };

    const mountSearchParameters = (): Parameter[] => {
        var parameters: Parameter[] = [];
        parameters.push(new Parameter("status", "ABERTURA,ORÇAMENTO_ACEITE,EM_CURSO"));
        if (ShowAll === false) {
            parameters.push(new Parameter("technician", technicianCode === null ? "vazio" : technicianCode));
        }
        return parameters;
    };

    const getAssistance = async (docType: string, serie: string, number: number) => {
        setIsLoadingResults(true);
        var assistance: GetAssistanceDTO = {
            docType: docType,
            serie: serie,
            number: number,
        };

        var response = await assistanceService.GetAssistance(assistance);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoadingResults(false);
            return;
        }

        navigate(`/Workshop/Assistance/${response.obj?.id}`);
        setIsLoadingResults(false);
    };

    const handleNavigation = async (assistanceCardPosition: number) => {
        if (assistanceCardPosition < 0) {
            assistanceCardPosition = 0;
        }
        if (assistanceCardPosition >= 0 && assistanceCardPosition < assistancesData.length) {
            navigate(`/Workshop/Assistance/${assistancesData[assistanceCardPosition].assistanceId}`);
        } else {
            console.error("Index (negativo):", assistanceCardPosition);
        }
    };

    const intl = useIntl();

    return (
        <>
            <Row style={{ justifyContent: "center" }}>
                {isLoadingResults === false ? (
                    <Col xl={3} lg={4} md={5} sm={9} xs={12}>
                        <ButtonComponent
                            onClick={() => setShowAll(!ShowAll)}
                            text={intl.formatMessage({ id: ShowAll ? "AssistanceWorkshopListB.ShowMine" : "AssistanceWorkshopListB.ShowAll" })}
                            style={{ width: "95%" }}
                        />
                    </Col>
                ) : (
                    ""
                )}
            </Row>
            {isLoadingResults ? (
                <Row style={{ justifyContent: "center", alignItems: "center" }}>
                    <div
                        className="loading"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <span>
                            {" "}
                            <FormattedMessage id="Common.Loading.DataLoading" />
                            ...{" "}
                        </span>
                        <CircularProgress style={{ marginLeft: "10px" }} size={"25px"} />
                    </div>
                </Row>
            ) : (
                assistancesData.length > 0 && (
                    <Row>
                        {assistancesData.map((element, index) => {
                            var i = index + 1;
                            // If para verificar se os números são pares ou ímpares e fazer .map em duas colunas (Se retirar isto ele faz 6 registo apenas numa coluna).
                            if (index % 2 !== 0) {
                                return (
                                    <Row key={index - 2} style={{ justifyContent: "center", alignItems: "center", marginTop: "11px" }}>
                                        <Col
                                            xl={2}
                                            lg={2}
                                            md={6}
                                            sm={6}
                                            xs={6}
                                            style={{ display: "flex", justifyContent: "right", alignItems: "center" }}
                                        >
                                            {element && (
                                                <BigButton
                                                    path={""}
                                                    onClickFunction={() =>
                                                        assistancesData[index].assistanceId ?
                                                            handleNavigation(i - 2) :
                                                            getAssistance(
                                                                assistancesData[i - 2].docType,
                                                                assistancesData[i - 2].serie,
                                                                assistancesData[i - 2].number
                                                            )
                                                    }
                                                    label={`${assistancesData[i - 2].docType} ${assistancesData[i - 2].serie} ${assistancesData[i - 2].number
                                                        }\n${assistancesData[i - 2].equipment?.carPlate}\n\n${assistancesData[i - 2].status
                                                        }\n\n${assistancesData[i - 2].workshopInternalNumber}
                                                    `}
                                                />
                                            )}
                                        </Col>
                                        <Col
                                            xl={2}
                                            lg={2}
                                            md={6}
                                            sm={6}
                                            xs={6}
                                            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                        >
                                            {element && (
                                                <BigButton
                                                    path={""}
                                                    onClickFunction={() =>
                                                        assistancesData[index].assistanceId ?
                                                            handleNavigation(i - 1) :
                                                            getAssistance(
                                                                assistancesData[i - 1].docType,
                                                                assistancesData[i - 1].serie,
                                                                assistancesData[i - 1].number
                                                            )
                                                    }
                                                    label={`${assistancesData[i - 1].docType} ${assistancesData[i - 1].serie} ${assistancesData[i - 1].number
                                                        }\n${assistancesData[i - 1].equipment?.carPlate}\n\n${assistancesData[i - 1].status
                                                        }\n\n${assistancesData[i - 1].workshopInternalNumber}
                                                    `}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                );
                            } else {
                                if (assistancesData[i] == null) {
                                    return (
                                        <Row key={index - 2} style={{ justifyContent: "center", alignItems: "center", marginTop: "11px" }}>
                                            <Col
                                                xl={2}
                                                lg={2}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                                style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                            >
                                                {element && (
                                                    <BigButton
                                                        path={""}
                                                        onClickFunction={() =>
                                                            assistancesData[index].assistanceId ?
                                                                handleNavigation(index) :
                                                                getAssistance(
                                                                    assistancesData[index].docType,
                                                                    assistancesData[index].serie,
                                                                    assistancesData[index].number
                                                                )
                                                        }
                                                        label={`${assistancesData[index].docType} ${assistancesData[index].serie} ${assistancesData[index].number
                                                            }\n${assistancesData[index].equipment?.carPlate}\n\n${assistancesData[i - 1].status
                                                            }\n\n${assistancesData[index].workshopInternalNumber}
                                                        `}
                                                    />
                                                )}
                                            </Col>
                                        </Row>
                                    );
                                }
                            }
                        })}
                    </Row>
                )
            )}

            <Row style={{ justifyContent: "center", alignItems: "center", marginTop: "10px", marginRight: "16px" }}>
                <Col xl={1} lg={2} md={3} sm={3} xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "center" }}>
                    <ButtonComponent
                        text={intl.formatMessage({ id: "AssistanceWorkshopListB.Previous" })}
                        onClick={() => fetchData(currentPage ? currentPage - 1 : 1)}
                        disabled={isLoadingResults || (currentPage && currentPage <= 1) ? true : false}
                    />
                </Col>
                <Col xl={2} lg={2} md={3} sm={3} xs={4} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <span className="paginationNumberIndicator">
                        <FormattedMessage id="Common.Labels.Page" /> <strong>{currentPage}</strong>{" "}
                        <FormattedMessage id="Common.Labels.Of" /> <strong>{pageCount}</strong>
                    </span>
                </Col>
                <Col xl={1} lg={2} md={3} sm={3} xs={4} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
                    <ButtonComponent
                        text={intl.formatMessage({ id: "AssistanceWorkshopListB.Next" })}
                        onClick={() => fetchData(currentPage ? currentPage + 1 : pageCount)}
                        disabled={isLoadingResults || (currentPage && currentPage >= pageCount) ? true : false}
                    />
                </Col>
            </Row>
        </>
    );
}
